import React from "react";
import { useState, useContext } from "react";
import { Link } from 'react-router-dom';

import SearchBar from "./common/SearchBar";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';

function Form({form}){

  return(
    <tr className="">
      <td><Link className="" to={`/form_builder/` + form.id}> {form.form_code}</Link></td>
      <td>{form.name}</td>
      <td>{form.year} </td>
      <td>{form.cycle}</td>
      <td>{form.section}</td>
    </tr>
  )

}


export default function FormList() {

  const [forms, setForms] = useState([])
  const [searchText, setSearchText] = useState('');
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {

    let forms = axios_api.get(api_url + '/forms', {
      headers: {"Authorization": token},
      params: {"year": 2025}
    });

    forms.then(
      (result) => {
        let apiReturnedForms = result.data;
        setForms(apiReturnedForms);
      },
      (error) => {
        console.log(error)
        setForms([]);
      }
    );

  }, []);


  let rows = [];
  for(let i in forms) {
    if (
      forms[i].form_code.toLowerCase().indexOf(searchText.toLowerCase()) === -1 &&
      forms[i].name.toLowerCase().indexOf(searchText.toLowerCase()) === -1
    ) {
      //pass
    } else {
      rows.push(
        <Form
          key={forms[i].id}
          form={forms[i]}  
        />
      );
    }

  }

  return(
    <>
      <div className="row">
        <h3 className="m-3">Формы</h3>
      </div>
      <Link className="lk-button ms-3 mt-3" to={`/form_create`}>Создать форму</Link>
      <div className="m-3">
        <SearchBar
          key="SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
      </div>
      <div className="row m-3">
        <table className="table">
          <thead>
            <tr> 
              <th>код формы</th>
              <th>имя формы</th>
              <th>год</th>         
              <th>цикл</th>
              <th>section</th>  
            </tr>
          </thead>
          <tbody>
            {rows} 
          </tbody>
        </table>
      </div>
    </>
  );
}
